import { SUPPORT_EMAIL_ADDRESS } from "common/constants/marketing";
import Footer from "lib/components/footers/LandingPageFooter";
import Navbar from "lib/components/home/Navbar";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "./MaintenancePage.module.scss";

interface MaintenancePageProps {
  endTime: string | null;
  message: string | null;
}

const DEFAULT_MESSAGE =
  "Higharc is currently undergoing scheduled maintenance. We'll be back as soon as possible — thank you for your patience.";

function formatEndTime(endTime: string | null): string | null {
  if (!endTime) {
    return null;
  }
  const date = new Date(endTime);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toLocaleString();
}

export default function MaintenancePage({ endTime, message }: MaintenancePageProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  const formattedEndTime = formatEndTime(endTime);

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Maintenance")}</title>
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <div className="grid-column-desktop-6" />
        <div className="grid-column-desktop-6 grid-column-mobile-12">
          <div data-testid="maintenance-page">
            <h2>
              <span role="img" aria-label="Construction">
                🚧
              </span>{" "}
              Under maintenance
            </h2>
            <p className={styles.message}>{message ?? DEFAULT_MESSAGE}</p>
            {formattedEndTime && (
              <p>
                Expected to be back by <strong>{formattedEndTime}</strong>.
              </p>
            )}
            <p>
              Need help? Contact <a href={`mailto:${SUPPORT_EMAIL_ADDRESS}`}>{SUPPORT_EMAIL_ADDRESS}</a>.
            </p>
          </div>
        </div>
        <div className="grid-column-desktop-6" />
      </div>
      <Footer />
    </div>
  );
}
